import { defineStore } from 'pinia';
import { store } from '/@/store';

let timer;
export const useBrowserExtensionStore = defineStore({
  id: 'browser-extension',
  state: () => ({
    isInstallBrowserExtension: false,
    browserExtensionInfo: undefined as undefined | any,
  }),
  getters: {},
  actions: {
    handle(e) {
      clearTimeout(timer);
      this.isInstallBrowserExtension = true;
      this.browserExtensionInfo = e.detail;
      timer = setTimeout(() => {
        this.isInstallBrowserExtension = false;
        this.browserExtensionInfo = undefined;
      }, 3000);
    },

    init() {
      document.addEventListener('lingtuBrowserExtensionReady', this.handle);
    },

    imageSearch(options: { websiteType: string; searchType: string; imgUrl: string }) {
      const pluginEvent = new CustomEvent('lingtuBrowserExtensionImageSearch', {
        detail: options,
      });
      document.dispatchEvent(pluginEvent);
    },
  },
});

export function useBrowserExtensionStoreWithOut() {
  return useBrowserExtensionStore(store);
}
